import React from 'react';
import classNames from 'classnames';

import css from './IconSchedule.module.css';

/**
 * Add icon: "+"
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} "add" icon
 */
const IconSchedule = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M27.9164 5.93337V3.33337C27.9164 2.65004 27.3497 2.08337 26.6664 2.08337C25.9831 2.08337 25.4164 2.65004 25.4164 3.33337V5.83337H14.5831V3.33337C14.5831 2.65004 14.0164 2.08337 13.3331 2.08337C12.6497 2.08337 12.0831 2.65004 12.0831 3.33337V5.93337C7.58306 6.35004 5.39973 9.03337 5.0664 13.0167C5.03306 13.5 5.43306 13.9 5.89973 13.9H34.0997C34.5831 13.9 34.9831 13.4834 34.9331 13.0167C34.5997 9.03337 32.4164 6.35004 27.9164 5.93337Z"
        fill="#A9DBFB"
      />
      <path
        d="M33.3333 16.4H6.66667C5.75 16.4 5 17.15 5 18.0667V28.3334C5 33.3334 7.5 36.6667 13.3333 36.6667H26.6667C32.5 36.6667 35 33.3334 35 28.3334V18.0667C35 17.15 34.25 16.4 33.3333 16.4ZM15.35 30.35C15.1833 30.5 15 30.6167 14.8 30.7C14.6 30.7834 14.3833 30.8334 14.1667 30.8334C13.95 30.8334 13.7333 30.7834 13.5333 30.7C13.3333 30.6167 13.15 30.5 12.9833 30.35C12.6833 30.0334 12.5 29.6 12.5 29.1667C12.5 28.7334 12.6833 28.3 12.9833 27.9834C13.15 27.8334 13.3333 27.7167 13.5333 27.6334C13.9333 27.4667 14.4 27.4667 14.8 27.6334C15 27.7167 15.1833 27.8334 15.35 27.9834C15.65 28.3 15.8333 28.7334 15.8333 29.1667C15.8333 29.6 15.65 30.0334 15.35 30.35ZM15.7 23.9667C15.6167 24.1667 15.5 24.35 15.35 24.5167C15.1833 24.6667 15 24.7834 14.8 24.8667C14.6 24.95 14.3833 25 14.1667 25C13.95 25 13.7333 24.95 13.5333 24.8667C13.3333 24.7834 13.15 24.6667 12.9833 24.5167C12.8333 24.35 12.7167 24.1667 12.6333 23.9667C12.55 23.7667 12.5 23.55 12.5 23.3334C12.5 23.1167 12.55 22.9 12.6333 22.7C12.7167 22.5 12.8333 22.3167 12.9833 22.15C13.15 22 13.3333 21.8834 13.5333 21.8C13.9333 21.6334 14.4 21.6334 14.8 21.8C15 21.8834 15.1833 22 15.35 22.15C15.5 22.3167 15.6167 22.5 15.7 22.7C15.7833 22.9 15.8333 23.1167 15.8333 23.3334C15.8333 23.55 15.7833 23.7667 15.7 23.9667ZM21.1833 24.5167C21.0167 24.6667 20.8333 24.7834 20.6333 24.8667C20.4333 24.95 20.2167 25 20 25C19.7833 25 19.5667 24.95 19.3667 24.8667C19.1667 24.7834 18.9833 24.6667 18.8167 24.5167C18.5167 24.2 18.3333 23.7667 18.3333 23.3334C18.3333 22.9 18.5167 22.4667 18.8167 22.15C18.9833 22 19.1667 21.8834 19.3667 21.8C19.7667 21.6167 20.2333 21.6167 20.6333 21.8C20.8333 21.8834 21.0167 22 21.1833 22.15C21.4833 22.4667 21.6667 22.9 21.6667 23.3334C21.6667 23.7667 21.4833 24.2 21.1833 24.5167Z"
        fill="#A9DBFB"
      />
    </svg>
  );
};

export default IconSchedule;
